var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.circles&&_vm.circles.length>0)?_c('div',{staticClass:"l-audio-circle"},_vm._l((_vm.circles),function(item,index){return _c('div',{key:index,staticClass:"l-circle",class:{'isActive':item.active}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }